<template>
  <v-container fluid>
    <v-card max-width="400px" class="mt-4 mx-auto pa-4" color="primary">
      <img src="../assets/ic_logotypewhite_1.svg" alt="logo" class="mt-2 mx-auto d-block" style="width: 80%;" />
      <v-card-text class="white--text">
        <div class="display-1">
          Welcome to FastTrack Admin
        </div>

        <div class="subtitle-1 mt-5">
          Get started by selecting something in the menu on the left
        </div>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
export default {
}
</script>
